import styled from "styled-components";

export const ColoredParagraph = styled.p`
  ${(props: { color: string }) => `color: ${props.color}`};
`;
ColoredParagraph.displayName = "ColoredParagraph";
